/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:

import $ from 'jquery';
window.$ = $; // Para plugins que dependen de window.$
window.jQuery = $; // Para plugins que dependen de window.jQuery

import Rails from "@rails/ujs";
Rails.start();

import moment from 'moment';
import 'moment/dist/locale/es';
window.moment = moment;
moment.locale('es');

//import flatpickr from "flatpickr";
//import "flatpickr/dist/flatpickr.min.css"; // Import the default CSS

import "@nathanvda/cocoon"; // Importar Cocoon correctamente

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

import 'select2'
import 'select2/dist/css/select2.css'
import '../plugins/fullcalendar/fullcalendar.bundle'
//import '../widgets/calendar/calendar'

//if (document.body.dataset.controller === 'dashboard') {
    import('../widgets/calendar/dashboard_calendar')
//}
//import './custom/select2_init.js'


$('.select2').select2({
    width: '100%',
    placeholder: 'Selecciona una o más unidades'
});

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

// import '../plugins/plugins.bundle.js';
// import '../components/layout/scripts.bundle.js';
// import '../components/auth/general.js';
//import '../widgets/widgets.bundle.js';

import './chatbot'
import './chatbot_imported'
// import '../channels/index'
import './reconciliation'
import { tns } from "tiny-slider/src/tiny-slider";
import './daterangepicker'
import ApexCharts from 'apexcharts'
// import './companion'
import './chat_audio'